import { hydrateWidgets } from 'DVWebNodeUtils';
import { RetailNav } from '../../widgets/DVWebNodeNav/RetailNav';
hydrateWidgets(RetailNav);